import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type DeclaracaoResponsabilidadeTecnicaPjJob = ReportJob;
export type DeclaracaoResponsabilidadeTecnicaPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Declaração de Responsabilidade Técnica PJ. */
@Injectable({ providedIn: 'root' })
export class DeclaracaoResponsabilidadeTecnicaPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'declaracao-responsabilidade-tecnica-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.declaracaoResponsabilidadeTecnicaPj;
}
